var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailEntryDecoration = function SvgEmailEntryDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 85,
    fill: "none",
    viewBox: "0 21 400 85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M21.054 63.16h21.052v21.052H21.054z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M42.106 63.16h21.052v21.052H42.106z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#129223",
    d: "M63.159 63.16h21.052v21.052H63.159z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#37499A",
    d: "M84.212 63.16h21.052v21.052H84.212z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M105.264 63.16h21.052v21.052h-21.052zM126.317 63.16h21.052v21.052h-21.052zM147.369 63.16h21.052v21.052h-21.052z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M168.422 63.16h21.052v21.052h-21.052z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDE9CA",
    d: "M189.474 63.16h21.052v21.052h-21.052z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M210.527 63.16h21.052v21.052h-21.052z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#37499A",
    d: "M231.579 63.16h21.052v21.052h-21.052z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#129223",
    d: "M252.632 63.16h21.052v21.052h-21.052z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M273.684 63.16h21.052v21.052h-21.052z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M294.737 63.16h21.052v21.052h-21.052z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M315.789 63.16h21.052v21.052h-21.052z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M336.842 63.16h21.052v21.052h-21.052zM357.895 63.16h21.052v21.052h-21.052z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M189.474 63.16v21.052h-21.052V63.16z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#129223",
    d: "M189.474 84.213v21.052h-21.052V84.213z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M400 0v21.052h-21.052V0zM400 21.053v21.052h-21.052V21.053z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M400 42.105v21.052h-21.052V42.105z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#37499A",
    d: "M400 63.158V84.21h-21.052V63.158z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M400 84.21v21.053h-21.053V84.21z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDE9CA",
    d: "M84.211 84.213v21.052H63.159V84.213z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M294.737 84.214v21.052h-21.052V84.214z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDE9CA",
    d: "M21.054 21.053h21.052v21.052H21.054z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M42.106 21.053h21.052v21.052H42.106z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M63.159 21.053h21.052v21.052H63.159z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M84.212 21.053h21.052v21.052H84.212zM21.054 42.107h21.052v21.052H21.054z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#129223",
    d: "M42.106 42.107h63.158v21.052H42.106z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M0 105.263V84.211h21.052v21.052z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#127400",
    d: "M0 84.21V63.158h21.052V84.21zM0 63.158V42.106h21.052v21.052z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#37499A",
    d: "M0 42.106V21.054h21.052v21.052z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB02",
    d: "M0 21.053V.001h21.052v21.052z"
  })));
};
export default SvgEmailEntryDecoration;